import {Reducer} from "redux";
import {IBannerSassState} from "./types";
import * as actions from "../sass/actions";
import {ActionType, getType} from "typesafe-actions";
import {defaultBannerSass, defaultMasterBannerSass} from "./defaults";
import mergeWith from "lodash/mergeWith";

export type BannerSassAction = ActionType<typeof actions>;


const initialBannerSassState: IBannerSassState = {
    bannerSass: {
        byId: {
            "default_child_sass": defaultBannerSass,
            "default_master_sass": defaultMasterBannerSass
        },
    },
    isLoading: false,
    activeBannerSass: defaultBannerSass,
    activeMasterBannerSass: defaultMasterBannerSass,
}

export const bannerSassReducer: Reducer<IBannerSassState, BannerSassAction> = (
    state = initialBannerSassState,
    action
) => {
    switch (action.type) {
        case getType(actions.modifyingActiveBannerSassAction):
            const activeBannerSass = mergeWith({}, state.activeBannerSass, action.payload.bannerSass);
            return {
                ...state,
                activeBannerSass: activeBannerSass
            }
        default:
            return state;
    }
}